import { KbGeometry } from '@kb3d/models/classes';
import { Token } from '@kb3d/models/classes/token';
import { MeshNode } from '../classes/meshes/mesh-node';
import { isCustomMeshNode } from '../classes/meshes/mesh-utilities';
import { HttpService } from './http-service';
import { attachLoadingTimer } from './loading-timer-helper';

const geometryCache = new Map<string, Promise<KbGeometry | null>>();

export class MeshService {
    constructor(private httpService: HttpService, private assetRoot?: string) {}
    /**
     * Loads the geometry for a mesh node and adds it to the node, mutating the node object.
     * @param meshNode Mesh node to load geometry for
     */
    public hydrateGeometry<T extends MeshNode>(meshNode: T): Promise<T> {
        if (!isCustomMeshNode(meshNode) || !meshNode.geometryId) {
            return Promise.resolve(meshNode);
        } else {
            let request = geometryCache.get(meshNode.geometryId);
            let shared = false;

            if (!request) {
                request = attachLoadingTimer(
                    this.httpService.getBinary(`${this.assetRoot}/meshes/${meshNode.geometryId}`, 'arraybuffer', true)
                ).then(
                    response => {
                        if (response && response.data) {
                            const geometry = meshNode._manager!.create(Token.KbGeometry);
                            geometry.extractFromBinary(response.data, meshNode);
                            return geometry;
                        }
                        return Promise.reject();
                    },
                    err => {
                        console.error(`Geometry for "${meshNode.name}" could not be loaded`, err);
                        return null;
                    }
                );
                geometryCache.set(meshNode.geometryId, request);
            } else {
                shared = true;
            }

            return request.then(geometry => {
                if (geometry) {
                    if (shared) {
                        geometry.shared = true;
                    }

                    meshNode._geometry = geometry;
                }
                return meshNode;
            });
        }
    }
}
